export const getExportWidthPx = (element: Element, useWidestAncestor: boolean | undefined): number => {
  try {
    if (!useWidestAncestor) {
      return Math.max(1, element.clientWidth || 0);
    }
    let maxW = element.clientWidth || 0;
    for (let el: Element | null = element; el; el = el.parentElement) {
      maxW = Math.max(maxW, el.clientWidth || 0);
    }
    return Math.max(1, Math.min(maxW, 4096));
  } catch {
    const width = Math.max(1, element.clientWidth || 0);
    return useWidestAncestor ? Math.min(width, 4096) : width;
  }
};
